/* eslint-disable no-console */
<template>
  <app-modal class="download-report-modal" @close="close">
    <app-modal-default @close="close">
      <template v-slot:header>
        {{$ml.get('PDF report')}}
      </template>
      <div class="body">
        <div class="text">
          {{$ml.get('Choose parts of your program that you want to include in your PDF report')}}:
        </div>
        <div class="pages">
          <div class="top">
            <app-checkbox
              :value="allSelected"
              @input="onSelectAll"
              :label="$ml.get('Full PDF report')"
            />
          </div>
          <div class="list">
            <app-checkbox
              v-model="item.active"
              v-for="item in filteredPages"
              :label="item.label"
            />
          </div>
        </div>

        <div class="bot-text">
          {{$ml.get('Your PDF report will include')}}: <br>
          <b>{{ included }}</b>
        </div>

        <div class="actions">
          <app-btn styling="inline" @click="close">{{$ml.get('Cancel')}}</app-btn>
          <app-btn
            :loading="loading"
            @click="download"
          >
            {{$ml.get('Download')}}
          </app-btn>
        </div>
      </div>
    </app-modal-default>
    <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="false"
        
        :manual-pagination="true"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="100%"
        :html-to-pdf-options="{margin: [5, 0, 5, 0], filename: $store.getters['program/data'].name + '.pdf', image: {type: 'png', quality: 1}}"
        
 
        @hasDownloaded="hasGenerated($event)"
        ref="html2Pdf"
    >
        <section slot="pdf-content">
            <div class="report">
              <General class="section html2pdf__page-break"  v-if="reportData.program"/>
              <SoilTest class="section" v-if="reportData.soilTest"/>
              <WaterTest class="section" v-if="reportData.waterTest"/>
              <TissueTest class="section" v-if="reportData.tissueTest"/>
              <MediaAnalysis class="section" v-if="reportData.mediaAnalysis"/>
              <Liming class="section html2pdf__page-break" v-if="reportData.liming"/>
              <BaseDressing class="section html2pdf__page-break" v-if="reportData.baseDressing"/>
              <Adjust class="section html2pdf__page-break" v-if="reportData.adjust"/>
              <Schedule class="section" v-if="reportData.schedule"/>
              <FertSummary class="section html2pdf__page-break" v-if="reportData.fertSummary"/>
              <Fertigation class="section html2pdf__page-break" v-if="reportData.fertigation"/>
              <Blend class="section" v-if="reportData.blend"/>
            </div>
        </section>
    </vue-html2pdf>
  </app-modal>
</template>

<script>
import API from '@/api';

import { ErrorHandlerMixin } from '@/mixins/error-handler.mixin';

import MainHeader from '@/views/report/components/common/MainHeader'
import Schedule from '@/views/report/sections/Schedule'
import General from '@/views/report/sections/General'
import Adjust from '@/views/report/sections/Adjust'
import Fertigation from '@/views/report/sections/Fertigation'
import Blend from '@/views/report/sections/Blend'
import BaseDressing from '@/views/report/sections/BaseDressing'
import SoilTest from '@/views/report/sections/SoilTest'
import TissueTest from '@/views/report/sections/TissueTest'
import WaterTest from '@/views/report/sections/WaterTest'
import MediaAnalysis from '@/views/report/sections/MediaAnalysis'
import Liming from '@/views/report/sections/Liming'
import FertSummary from '@/views/report/sections/FertSummary'
import { mapGetters } from 'vuex'

import VueHtml2pdf from 'vue-html2pdf'

export default {
  mixins: [ ErrorHandlerMixin ],
  components: {
    VueHtml2pdf,
    Schedule,
    General,
    MainHeader,
    Adjust,
    Fertigation,
    Blend,
    BaseDressing,
    SoilTest,
    WaterTest,
    TissueTest,
    MediaAnalysis,
    Liming,
    FertSummary,
  },
  data() {
    return  {
      loading: false,
      reportData: {},
      pages: [
        {
          label: this.$ml.get('Soil test'),
          key: 'soilTest',
          active: true,
        },
        {
          label: this.$ml.get('Water test'),
          key: 'waterTest',
          active: true,
        },
        {
          label: this.$ml.get('Tissue test'),
          key: 'tissueTest',
          active: true,
        },
        {
           label: this.$ml.get('Media analysis'),
            key: 'mediaAnalysis',
            active: true,
        },
        {
          label: this.$ml.get('Liming'),
          key: 'liming',
          active: true,
        },
        {
          label: this.$ml.get('Adjusted values'),
          key: 'adjust',
          active: true,
        },
        {
          label: this.$ml.get('Base dressing'),
          key: 'baseDressing',
          active: true,
        },
        {
          label: this.$ml.get('Fertilizer schedule'),
          key: 'schedule',
          active: true,
        },
        {
          label: this.$ml.get('Fertilizer summary'),
          key: 'fertSummary',
          active: true,
        },
        {
          label: this.$ml.get('Fertigation'),
          key: 'fertigation',
          active: true,
        },
        {
          label: this.$ml.get('Blend'),
          key: 'blend',
          active: true,
        },
      ],
      selectedPages: []
    }
  },
  methods: {
    hasGenerated(e) {
      this.loading = false;
      // this.$store.commit('pdf/removeData');
      this.$router.push({path: '/dashboard/global-pdf', params: {data: this.reportData, pages: this.selectedPages}})
      this.close();
    },

    onSelectAll() {
      if(this.allSelected) {
        this.pages.forEach(n => n.active = false);
      } else this.pages.forEach(n => n.active = true);
      
    },

    close() {
      this.$emit('close');
    },

    async download() {
      this.loading = true;
      const pages = this.selectedPages = this.pages.filter(n => n.active).map(n => n.key);
      API.pdf.getGlobalPdf(this.$route.params.programId, pages)
        .then(res => {
          var blob = new Blob([ res.data ], { type: 'application/pdf' });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = this.$store.getters['program/data'].name + '.pdf';
          link.click();
          this.$store.dispatch('user/availableReports');
          this.close();
        })
        .catch(err => {
          // this api returns a blob res - so i 
          // convert it to string first
          const reader = new FileReader();
          reader.addEventListener('loadend', e => {
            err.response.data = JSON.parse(e.srcElement.result);
            this.handleErrorAsNotifications(err)
          });
          // Start reading the blob as text.
          reader.readAsText(err.response.data);
        })
        .finally(() => {
          this.loading = false;
        });

      // API.pdf.getGlobalPdf(this.$route.params.programId, pages)
      //   .then(res => {
      //     console.log('then');
      //     console.log(res);
      //     // var blob = new Blob([ res.data ], { type: 'application/pdf' });
      //     // var link = document.createElement('a');
      //     // link.href = window.URL.createObjectURL(blob);
      //     // link.download = this.$store.getters['program/data'].name + '.pdf';
      //     // link.click();
      //     // this.$store.dispatch('user/availableReports');
      //     // this.close();
      //   })
      //   .catch(err => {
      //     // this api returns a blob res - so i 
      //     // convert it to string first
      //       //const reader = new FileReader();
      //       console.log('vse huynya');
      //       console.log(err.message);
      //     //reader.addEventListener('loadend', e => {
      //       //err.response.data = JSON.parse(e.srcElement.result);
      //       //this.handleErrorAsNotifications(err)
      //     //});

      //     // Start reading the blob as text.
      //     //reader.readAsText(err.response.data);
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });
    },
  },
  computed: {

    filteredPages() {
      const prog = this.$store.getters['program/data'];
      const available_pages = {
        soilTest: prog.soilTest && prog.soilTestId,
        waterTest: prog.waterTest && prog.waterTestId,
        tissueTest: prog.tissueTest && prog.tissueTestId,
        mediaAnalysis: prog.mediaAnalysis && prog.mediaAnalysisId,
        liming: prog.liming,
        adjust: true,
        baseDressing: prog.baseDressing,
        schedule: true,
        fertSummary: true,
        fertigation: prog.fertigation,
        blend: prog.blend,
      };
      return this.pages.filter(n => available_pages[n.key]);
    },

    included() {
      const pages = this.filteredPages
        .filter(n => n.active)
        .map(n => n.label);

      return [ this.$ml.get('General settings'), ...pages ].join(', ');
    },

    allSelected() {
      return !this.pages.find(n => !n.active);
    },
  },
}
</script>

<style lang="scss" scoped>

.download-report-modal {
  .app-modal-default {
    max-width: 500px;
    width: 100%;
  }

  .text {
    line-height: 1.5;
    color: #666666;
    margin-bottom: 20px;
  }

  .bot-text {
    margin-top: 20px;
    line-height: 1.5;
    color: #666666;
  }

  .actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    padding-top: 20px;

    > * {
      margin-left: 20px;
    }
  }

  .pages {

    .top {
      border-top: 1px solid rgba($color: #333, $alpha: 0.1);
      border-bottom: 1px solid rgba($color: #333, $alpha: 0.1);
      padding: 10px 0;
    }

    .list {
      padding: 10px 0;
      border-bottom: 1px solid rgba($color: #333, $alpha: 0.1);
    }
  }
}

.section {
  padding: 30px;
}

</style>
